module.exports = __webpack_public_path__ + "img/lineup_desc.750baa99.png";